import { combineReducers } from "redux";
import searchReducer from "../pages/home/state/search-reducer";

const appReducers = combineReducers(
    {
        searchReducer: searchReducer,
    }
)

export default appReducers;